import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock } from "lucide-react";

const RecentOrders = () => {
  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-200">
      <div className="flex items-center justify-between mb-6">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <Clock className="h-5 w-5 text-[#F97316]" />
            Recent Orders
          </h2>
          <p className="text-sm text-muted-foreground">Latest customer purchases</p>
        </div>
        <Button variant="outline" size="sm">View All</Button>
      </div>
      <div className="space-y-4">
        {[1, 2, 3].map((order) => (
          <div
            key={order}
            className="p-4 rounded-xl bg-gradient-to-r from-gray-50 to-transparent border border-gray-100 hover:border-[#9b87f5] transition-colors"
          >
            <div className="flex justify-between items-center">
              <div className="space-y-1">
                <p className="font-medium text-[#222222]">Order #{order}234</p>
                <p className="text-sm text-muted-foreground">2 items • Processing</p>
              </div>
              <div className="text-right space-y-1">
                <p className="font-medium text-[#8B5CF6]">$123.45</p>
                <p className="text-sm text-muted-foreground">2 mins ago</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default RecentOrders;